var organismMetadata = {
  9606: {
    commonName: 'Human',
    scientificName: 'Homo sapiens',
    assemblies: {
      default: 'GCF_000001405.26', // GRCh38
      GRCh38: 'GCF_000001405.26',
      GRCh37: 'GCF_000001405.13',
      NCBI36: 'GCF_000001405.12'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasInteractionCache: true,
    hasGeneStructureCache: true,
    hasProteinCache: true,
    hasSynonymCache: true,
    hasTissueCache: true,
    hasVariantCache: true
  },
  10090: {
    commonName: 'Mouse',
    scientificName: 'Mus musculus',
    assemblies: {
      default: 'GCF_000001635.27', // GRCm39
      GRCm39: 'GCF_000001635.27',
      GRCm38: 'GCF_000001635.20',
      MGSCv37: 'GCF_000001635.18'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasInteractionCache: true,
    hasGeneStructureCache: true,
    hasProteinCache: true,
    hasSynonymCache: true
  },
  9598: {
    commonName: 'Chimpanzee',
    scientificName: 'Pan troglodytes',
    assemblies: {
      'default': 'GCF_028858775.1',
      'NHGRI_mPanTro3-v1.1-hic.freeze_pri': 'GCF_028858775.1',
      'Pan_tro 3.0': 'GCF_000001515.7'
    },
    hasGeneCache: true,
    hasSynonymCache: true
  },
  10116: {
    commonName: 'Rat',
    scientificName: 'Rattus norvegicus',
    assemblies: {
      'default': 'GCF_000001895.5',
      'Rnor_6.0': 'GCF_000001895.5'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  3702: {
    commonName: 'Thale cress',
    scientificName: 'Arabidopsis thaliana',
    assemblies: {
      default: 'GCF_000001735.3', // TAIR10
      TAIR10: 'GCF_000001735.3'
    }
  },
  4530: {
    commonName: 'Rice',
    scientificName: 'Oryza sativa',
    assemblies: {
      'default': 'GCA_001433935.1',
      'IRGSP-1.0': 'GCA_001433935.1'
    }
  },
  4577: {
    commonName: 'Maize',
    scientificName: 'Zea mays',
    assemblies: {
      'default': 'GCA_000005005.5',
      'IRGSP-1.0': 'GCA_001433935.1'
    }
  },
  4641: {
    commonName: 'Banana',
    scientificName: 'Musa acuminata',
    assemblies: {
      default: 'mock'
    }
  },
  7227: {
    commonName: 'Fly',
    scientificName: 'Drosophila melanogaster',
    assemblies: {
      'default': 'GCA_000001215.4',
      'Release 6 plus ISO1 MT': 'GCA_000001215.4'
    },
    hasSynonymCache: true
  },
  7165: {
    commonName: 'Mosquito',
    scientificName: 'Anopheles gambiae',
    assemblies: {
      default: 'GCF_000005575.2'
    }
  },
  746128: {
    commonName: 'Aspergillis fumigatus',
    scientificName: 'Aspergillis fumigatus',
    assemblies: {
      default: 'GCF_000002655.1'
    }
  },
  227321: {
    scientificName: 'Aspergillus nidulans',
    assemblies: {
      default: 'GCF_000149205.2'
    }
  },
  5061: {
    commonName: 'black mold',
    scientificName: 'Aspergillus niger',
    assemblies: {
      default: 'GCF_003184595.1'
    }
  },
  5062: {
    commonName: 'koji',
    scientificName: 'Aspergillus oryzae',
    assemblies: {
      default: 'GCF_000184455.2'
    }
  },
  15368: {
    commonName: 'stiff brome',
    scientificName: 'Brachypodium distachyon',
    assemblies: {
      default: 'GCF_000005505.3'
    }
  },
  60711: {
    commonName: 'green monkey',
    scientificName: 'Chlorocebus sabaeus',
    assemblies: {
      default: 'GCF_015252025.1'
    }
  },
  7719: {
    commonName: 'Vase tunicate',
    scientificName: 'Ciona intestinalis',
    assemblies: {
      default: 'GCF_000224145.3'
    }
  },
  9685: {
    commonName: 'Cat',
    scientificName: 'Felis catus',
    assemblies: {
      default: 'GCF_000181335.3'
    },
    hasGeneCache: true
  },
  9031: {
    commonName: 'Chicken',
    scientificName: 'Gallus gallus',
    assemblies: {
      default: 'GCF_000002315.6'
    },
    hasGeneCache: true,
    hasParalogCache: true
  },
  9593: {
    commonName: 'Gorilla',
    scientificName: 'Gorilla gorilla',
    assemblies: {
      default: 'GCF_008122165.1'
    }
  },
  4513: {
    commonName: 'Barley',
    scientificName: 'Hordeum vulgare',
    assemblies: {
      default: 'GCA_901482405.1'
    }
  },
  9541: {
    commonName: 'Crab-eating macaque',
    scientificName: 'Macaca fascicularis',
    assemblies: {
      default: 'GCF_000364345.1'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  9544: {
    commonName: 'Rhesus macaque',
    scientificName: 'Macaca mulatta',
    assemblies: {
      default: 'GCF_003339765.1'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  9597: {
    commonName: 'Bonobo',
    scientificName: 'Pan paniscus',
    assemblies: {
      default: 'GCF_013052645.1'
    }
  },
  9615: {
    commonName: 'Dog',
    scientificName: 'Canis lupus familiaris',
    assemblies: {
      default: 'GCF_014441545.1'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  9823: {
    commonName: 'Pig',
    scientificName: 'Sus scrofa',
    assemblies: {
      default: 'GCF_000003025.6'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  4932: {
    commonName: 'Yeast',
    scientificName: 'Saccharomyces cerevisiae',
    assemblies: {
      default: 'GCA_000146045.2',
      R64: 'GCA_000146045.2'
    }
  },
  5833: {
    commonName: 'malaria parasite',
    scientificName: 'Plasmodium falciparum',
    assemblies: {
      default: 'GCA_000002765.3',
      GCA_000002765: 'GCA_000002765.3'
    }
  },
  6239: {
    commonName: 'worm',
    scientificName: 'Caenorhabditis elegans',
    assemblies: {
      default: 'GCF_000002985.6'
    },
    hasGeneCache: true,
    hasParalogCache: true,
    hasSynonymCache: true
  },
  4081: {
    commonName: 'tomato',
    scientificName: 'Solanum lycopersicum',
    assemblies: {
      default: 'GCF_000188115.4'
    }
  },
  4072: {
    commonName: 'pepper',
    scientificName: 'Capsicum annuum',
    assemblies: {
      default: 'GCF_000710875.1'
    }
  },
  3694: {
    commonName: 'black cottonwood',
    scientificName: 'Populus trichocarpa',
    assemblies: {
      default: 'GCF_000002775.5'
    }
  }
};

export {organismMetadata};
